<template>
  <b-card no-body v-draggable 
          class="popup generic-help-popup app-ctrl">
    <b-card-header  style=""
                    class="app-ctrl"
                    header-tag="div"
                    header-bg-variant="dark">
      <b-row class="mx-0 px-0">
        <b-col class="mx-0 px-0" cols="11">
          {{ title }}
        </b-col>
        <b-col class="mx-0 px-0 local-right" cols="1">
          <font-awesome-icon  class="cx-close-icon mx-1 clickable"
                              :icon="['far', 'times']"
                              @click="$emit('close')" />
        </b-col>
      </b-row>
    </b-card-header>

    <b-card-body>
      <slot></slot>
    </b-card-body>
  </b-card>
</template>

<script>
export default {
  props: {
    title:          { type: String }
  }
}
</script>

<style scoped>
  .generic-help-popup {
    box-shadow: 3px 3px 13px -3px var(--border-color-secondary);
    border: 1px solid var(--border-color-secondary);
    border-radius: var(--border-radius-popup);
    
    position: fixed !important;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    
    overflow: auto;
    width: 450px;


    height: auto;
    max-height: 80vh;
  }
  .local-right {
    text-align: right;
  }
  .svg-inline--fa.fa-w-10 {
    width: 1.0em;
  }
</style>